module.exports = __webpack_public_path__ + "img/DNADamage-OVCA_10X_TIP.61934881.png";